<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button @click="$utils.goBack($router)"   text="Quay lại" defaultHref="/tabs/main"></ion-back-button>
        </ion-buttons>
        <ion-title>Thống kê</ion-title>
        <ion-label slot="end" style="margin-right: 2vw"></ion-label>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="gametitle">
        <div class="title">
          <h2>Keno</h2>
        </div>
        <div class="title">
          <h2>Chẵn lẻ</h2>
        </div>
      </div>
      <div class="main" v-if="loaded">
        <MySelect2 :options="stageOpts" :value="stages" @change="onChange"></MySelect2>
        <div class="content">
          <table style="border-collapse: collapse; width: 100%; border: 1px solid #aaa;">
            <thead>
              <tr>
                <th width="14%"></th>
                <th width="18%">CHẴN 13+</th>
                <th width="18%">CHẴN 11-12</th>
                <th width="14%">HÒA</th>
                <th width="18%">LẺ 11-12</th>
                <th width="18%">LẺ 13+</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Kỳ ra</th>
                <td>{{ even.hit }}</td>
                <td>{{ smeven.hit }}</td>
                <td>{{ eventie.hit }}</td>
                <td>{{ smodd.hit }}</td>
                <td>{{ odd.hit }}</td>
              </tr>
              <tr>
                <th>Bước</th>
                <td>{{ even.step }}</td>
                <td>{{ smeven.step }}</td>
                <td>{{ eventie.step }}</td>
                <td>{{ smodd.step }}</td>
                <td>{{ odd.step }}</td>
              </tr>
              <tr>
                <th>Chưa về</th>
                <td>{{ even.miss }}</td>
                <td>{{ smeven.miss }}</td>
                <td>{{ eventie.miss }}</td>
                <td>{{ smodd.miss }}</td>
                <td>{{ odd.miss }}</td>
              </tr>
            </tbody>
          </table>
          <div class="history">
            <KenoResults :limit="parseInt(stages)"></KenoResults>
          </div>
        </div>
      </div>
      <div v-else style="color: #999;height: 74vh; display: flex; flex-direction: column; align-items: center; justify-content: center;">
        <div style="text-align: center;">
          Đang tải dữ liệu..
        </div>
        <div style="text-align: center">
          Vui lòng chờ
        </div>
      </div>
      <ion-fab vertical="bottom" horizontal="end" slot="fixed" v-if="isLogin">
        <ion-fab-button>
          <ion-icon :icon="ticket" @click="goBuyTicket"></ion-icon>
        </ion-fab-button>
      </ion-fab>
    </ion-content>
  </ion-page>
</template>


<style lang="scss" scoped>
  .gametitle {
    background-color:  #fac952;
    display: grid;
    grid-template-columns: auto 30%;
    border-bottom: 2px solid  #deb248;
    .title {
      h2 {
        margin: 0;
        padding: 3vw;
        font-weight: bold;
        color: white;
      }
      &:nth-child(2) {
        justify-self: end;
      }
    }
  }
  .main {
    padding: 1vw;
    .content {
      margin-top: 1vh;
      .history {
        margin-top: 1vh;
      }
      table {
        td, th {
          border: 1px solid #aaa;
          color: #222;
        }
        thead {
          th {
            background-color: #fce8b5;
            color: #000;
            padding: 10px 0;
            font-size: 11px;
          }
        }
        tbody {
          th {
            text-align: center;
            padding: 5px 0;
            font-weight: 600;
            color: #444;
            font-size: 12px;
          }
          td {
            text-align: right;
            padding: 5px;
            color: #333;
          }
        }
      }
    }
  }
</style>

<script>

  import MySelect2 from '@/components/MySelect2.vue';
  import KenoResults from '@/components/results/Keno.vue';
  import { defineComponent } from 'vue';
  import {
    IonPage,
    IonContent,
    IonHeader,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonToolbar,
    IonFab,
    IonFabButton,
    IonIcon,
    IonLabel,
  } from '@ionic/vue';
  import { ticket } from 'ionicons/icons';
  import authService from '@/services/auth';

  export default defineComponent({
    name: 'KenoOddEvenStats',
    components: {
      IonPage,
      IonContent,
      IonHeader,
      IonButtons,
      IonBackButton,
      IonTitle,
      IonToolbar,
      MySelect2,
      KenoResults,
      IonFab,
      IonFabButton,
      IonIcon,
      IonLabel,
    },
    computed: {
      isLogin() {
        return authService.user() && !authService.user().isAnonymous;
      },
    },
    data() {
      return {
        stageOpts: {
          10: "10 kỳ gần nhất",
          20: "20 kỳ gần nhất",
          30: "30 kỳ gần nhất",
          40: "40 kỳ gần nhất",
          50: "50 kỳ gần nhất",
          100: "100 kỳ gần nhất",
          200: "200 kỳ gần nhất"
        },
        stages: 10,
        odd: {},
        even: {},
        smodd: {},
        smeven: {},
        eventie: {},
        loaded: false,
      }
    },
    mounted() {
      setTimeout( () => {
        this.refresh();
      }, 500);
    },
    methods: {
      goBuyTicket() {
        if (this.$route.query.from && this.$route.query.from == '/keno') {
          this.$router.go(-1);
        } else {
          this.$router.push('/keno');
        }
      },
      refresh() {
        this.loaded = false;
        this.$utils.callAPI('GET', '/stats/keno', { type: 'oddeven', stages: this.stages }, false).then((resp) => {
          this.odd = resp.data.odd;
          this.even = resp.data.even;
          this.smodd = resp.data.smodd;
          this.smeven = resp.data.smeven;
          this.eventie = resp.data.eventie;
          this.$nextTick(() => {
            this.loaded = true;
          });
        });
      },
      onChange(val) {
        if (val != this.stages) {
          this.stages = val;
          this.refresh();
        }
      }
    },
    setup() {
      return {
        ticket
      }
    }
  })
</script>
